module.exports = __webpack_public_path__ + "staticVue/img/login-bg.e7de3c1f.jpg";